<template>
  <div class="section-height v-align-wrapper">
    <div class="v-align">
      <slot></slot>
		</div>
  </div>
</template>

<script>
export default {
  name: 'vertical-center',
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/rows/VerticalCenter.vue